import { render } from "./Affiliates.vue?vue&type=template&id=5e1b6b22"
import script from "./Affiliates.vue?vue&type=script&lang=js"
export * from "./Affiliates.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__